var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountWishlist = function SvgIconAccountWishlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.002 1.774a5 5 0 0 1 7.065 7.054L9 15.904 1.936 8.828a5 5 0 0 1 7.066-7.054m5.688 1.368a3.33 3.33 0 0 0-4.574-.128l-1.113.999-1.113-.998A3.334 3.334 0 0 0 3.15 7.686l5.85 5.86 5.85-5.86a3.333 3.333 0 0 0-.16-4.544"
  })));
};
export default SvgIconAccountWishlist;